import {filter, map, Observable, of, shareReplay, switchMap, take} from 'rxjs';
import {envUtil} from '@/helper/env';
import {semver} from '@/helper/bridge';
import {appVersion$ as appVersionStore} from '@/store/app';

const appVersion$ = new Observable((subscriber) => {
  appVersionStore.subscribe((appVersion) => {
    subscriber.next(appVersion);
  });
});

export const shouldUseAppWalletConnect$ = of(envUtil.isApp).pipe(
  switchMap((isApp) =>
    isApp
      ? appVersion$.pipe(
          filter(Boolean),
          map((appVersion) => semver.gte(appVersion, '5.1.0'))
        )
      : of(false)
  ),
  shareReplay(1)
);

export function defineWalletConnectBridge(callback) {
  if (typeof window !== 'undefined' && envUtil.isApp) {
    shouldUseAppWalletConnect$.pipe(take(1)).subscribe((shouldUseAppWalletConnect) => {
      if (shouldUseAppWalletConnect) {
        callback && callback();
      }
    });
  }
}
